module.exports = __webpack_public_path__ + "img/pump1.6da12a37.jpg";